$(document).ready(function () {
    function showMenuMobile() {
        const menuMobile = document.querySelector('.header-mobile__menu')
        if (!menuMobile) return;
        menuMobile.classList.add('show')
    }

    $('.header-mobile__actions--hambuger').on('click', function () {
        showMenuMobile()
        window.setOverlayBody()
        window.hidePopup()
    })

    function hideMenuMobile() {
        const menuMobile = document.querySelector('.header-mobile__menu')
        if (!menuMobile) return;
        menuMobile.classList.remove('show')
    }

    const headerSpotlightSearch = document.querySelector('.header__menu--search--spotlight-search')
    if (headerSpotlightSearch) {
        // $('#search').on('focus blur', function (e) {
        //     if (e.type == 'focus') {
        //         headerSpotlightSearch.classList.add('is-active')
        //     }
        // })

        document.addEventListener('click', function (e) {
            if (!e.target.closest(".header__menu--search--spotlight-search")) {
                if (e.target.classList.contains('input-search')) return;
                headerSpotlightSearch.classList.remove('is-active')
            }
        })
    }

    document.addEventListener('click', function (e) {
        // console.log(e.target);
        if (e.target.classList.contains('has-sub-menu') || e.target.closest('.has-sub-menu')) {
            let target = null
            if (e.target.classList.contains('has-sub-menu')) {
                target = e.target
            } else {
                target = e.target.closest('.has-sub-menu')
            }

            const navParent = target.closest('.announcement-bar-mobile__nav')
            const subMenu = target.querySelector('.announcement-bar-mobile__nav--item__sub')
            // subMenu.classList.toggle('show-sub-menu')

            const listSvg = target.querySelectorAll('svg')
            let svgRotate = null
            if (listSvg.length > 0) {
                svgRotate = listSvg[1]
            }

            if (subMenu.classList.contains('show-sub-menu')) {
                subMenu.classList.remove('show-sub-menu')
                if (svgRotate) {
                    svgRotate.style.transform = 'rotate(0deg)'
                }
                if (navParent) {
                    navParent.classList.add('overflow-scroll')
                    navParent.classList.remove('overflow-hidden')
                }
            } else {
                subMenu.classList.add('show-sub-menu')
                if (svgRotate) {
                    svgRotate.style.transform = 'rotate(180deg)'
                }
                if (navParent) {
                    navParent.classList.remove('overflow-scroll')
                    navParent.classList.remove('overflow-hidden')
                }
            }
        }


        // if (e.target.classList.contains('header-mobile__actions--hambuger') || e.target.closest('.header-mobile__actions--hambuger')) {
        //     let target = null
        //     if (e.target.classList.contains('header-mobile__actions--hambuger')) {
        //         target = e.target
        //     } else {
        //         target = e.target.closest('.header-mobile__actions--hambuger')
        //     }

        //     showMenuMobile()
        //     window.setOverlayBody()
        // }

        if (e.target.classList.contains('header-mobile__menu--content__item') || e.target.closest('.header-mobile__menu--content__item')) {
            let target = null
            if (e.target.classList.contains('header-mobile__menu--content__item')) {
                target = e.target
            } else {
                target = e.target.closest('.header-mobile__menu--content__item')
            }

            const subMenuTarget = target.querySelector('.header-mobile__menu--content__subMenu')
            if (subMenuTarget) {
                subMenuTarget.classList.toggle('show')
            }
        }

        // console.log(e.target);
        if (e.target.classList.contains('header-mobile__menu--head__close') || e.target.closest('.header-mobile__menu--head__close')) {
            hideMenuMobile()
            window.removeOverlayBody()
        }

        if (!e.target.closest('.announcement-bar-mobile__nav--item__sub')) {
            if (!e.target.closest('.announcement-bar-mobile__nav--item')) {
                const subMenuAnnouncementBars = document.querySelectorAll('.announcement-bar-mobile__nav--item__sub.show-sub-menu')
                if (subMenuAnnouncementBars.length > 0) {
                    subMenuAnnouncementBars.forEach(item => {
                        item.classList.remove('show-sub-menu')
                    })

                    const navParent = document.querySelector('.announcement-bar-mobile__nav')
                    if (navParent) {
                        navParent.classList.add('overflow-scroll')
                        navParent.classList.remove('overflow-hidden')
                    }
                }
            }
        }

        // if (e.target.classList.contains('header-mobile__actions--search') || e.target.closest('.header-mobile__actions--search')) {
        //     const searchBoxMobile = document.querySelector('#searchBox-mobile')
        //     if (searchBoxMobile) {
        //         window.setOverlayBody()
        //         searchBoxMobile.classList.add('show')
        //     }
        // }
    })

    const inputSearchMB = document.getElementById("spotlight-search_mobile")
    $(".header-mobile__actions--search").on("click", function () {
        const searchBoxMobile = $('#searchBox-mobile')
        if (searchBoxMobile) {
            window.setOverlayBody()
            searchBoxMobile.addClass('show')
            inputSearchMB && inputSearchMB.focus()
        }
    });

    // const announcementBarMobile = document.querySelector('.announcement-bar-mobile')
    // if (announcementBarMobile && (window.innerWidth < 992)) {
    //     const announcementBarMobileNav = announcementBarMobile.querySelector('.announcement-bar-mobile__nav')
    //     if (announcementBarMobileNav) {
    //         console.log(announcementBarMobileNav.clientWidth);
    //         console.log(window.innerWidth);

    //         // if (announcementBarMobileNav.clientWidth < window.innerWidth)
    //     }
    // }
});